var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'a' : 'div',{tag:"component",staticClass:"rhg-card",class:_vm.styleClass,on:{"click":_vm.onClick}},[_vm._t("header"),_c('div',{staticClass:"rhg-card-body"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }